import { MonitoringErrorHandler } from 'monitoring-error-handler'
import { store } from '@/store'

export class ErrorHandler {
  static handle(err, where, props?) {
    setTimeout(() => {
      // Necessary timeout because getter is a reactive property, and at first load its not available yet
      MonitoringErrorHandler.instance.trackException({
        exception: err,
        handledAt: where,
        properties: {
          displayName: store.getters.displayName,
          botAccountData: store.getters.botAccountData,
          botIdentity: store.getters.botIdentity,
          userIdentity: store.getters.userIdentity,
          ...props,
        },
      })
    })
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./src/utils/ErrorHandler.ts